import React, { useContext, useEffect, useState } from 'react'
import Table, { ColumnProps } from '../../Common/Table'
import UserContext, { Roles } from '../../../UserContext'
import get from 'lodash/get'
import { ApiFetch } from '../../Common/Api'
import { displayDateTime, displayPhone } from '../../../utilities'
import type { Pageable, ServiceRequestService } from '../../../models'
import type { Sortable, PageFilters } from '../../../models/interfaces'
import ServiceReadReceipt from '../../../models/ServiceReadReceipt'

type ViewReadReceiptsProps = { service: ServiceRequestService }


const ViewReadReceipts: React.FC<ViewReadReceiptsProps> = ({ service }) => {
    const [readReceipts, setReadReceipts] = useState<ServiceReadReceipt[]>([])
    const [totalRows, setTotalRows] = useState(0)
    const [loading, setLoading] = useState(true)
    const [filterValues, setFilterValues] = useState<Sortable & PageFilters>({ rowIndex: 0, pageSize: 10, sort: [['lastReadAt', 'desc']] })
    const { hasAnyRole } = useContext(UserContext)

    useEffect(() => {
        setLoading(true)
        ApiFetch<Pageable<ServiceReadReceipt>>('ServiceRequestServiceReadStatus/ReadReceipts', { serviceRequestServiceID: service.serviceRequestServiceID, ...filterValues })
            .then(({ results, totalRows }) => {
                setReadReceipts(results)
                setTotalRows(totalRows)
            })
            // eslint-disable-next-line no-console
            .catch(console.log)
            .finally(() => setLoading(false))
    }, [service, filterValues])

    if (hasAnyRole(Roles.Provider)) return null

    const columns: ColumnProps<ServiceReadReceipt> = [
        {
            title: 'Provider', dataIndex: 'name', sortable: true,
            render: (value, record) => <>
                {value}<br />
                <div className='contact_info'>
                    <span>{displayPhone(get(record, 'phone'))}</span><br />
                    <span>{get(record, 'email')}</span>
                </div>
            </>
        },
        { title: 'Date Viewed', dataIndex: 'lastReadAt', render: displayDateTime, sortable: true },
        { title: '# of Views', dataIndex: 'viewCount', sortable: true },

    ]

    return (
        <>
            <h5><i className='far fa-files-medical'></i>Read Receipts</h5>
            <br />
            {
                readReceipts.length
                    ? <Table
                        columns={columns}
                        data={readReceipts}
                        loading={loading}
                        totalRows={totalRows}
                        filters={filterValues}
                        setFilters={setFilterValues}
                        disableMultiColumnSort
                    />
                    : <p>No Views Yet</p>
            }
        </>
    )
}

export default ViewReadReceipts
